import SortableHeaderCell from 'components/shared/Helpers/SortableHeaderCell'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { dirname } from 'path'
import React from 'react'
import Highlighter from 'react-highlight-words'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { formValues, initialize } from 'redux-form'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import { selectProperty } from 'redux/properties'
import { Icon, Table } from 'semantic-ui-react'
import { classNames } from 'lib/utilities'

const mapStateToProps = (state, ownProps) => {
  const { properties, propertiesLoading } = state.properties
  const { dirtyForm } = state.navigation
  return { properties, propertiesLoading, dirtyForm }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      initialize,
      selectProperty,
      push,
      setDirtyFormState,
      confirmationModal,
    },
    dispatch
  )

class PropertiesList extends React.Component {
  state = {
    sortCol: 'id',
    direction: 'ascending',
  }

  sortBy(sortCol) {
    const { direction } = this.state

    this.setState({
      sortCol: sortCol,
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  getLockedIcon(property) {
    return (
      !property.active &&
      !property.read_only && (
        <Icon name="lock" color={config.semantic_ui.primary_color} />
      )
    )
  }

  getOptionalIcon(property) {
    return (
      property.optional &&
      !property.read_only && <Icon name="info circle" color="blue" />
    )
  }

  getPropertyList() {
    const { sortCol, direction } = this.state
    const {
      properties = [],
      filterText = '',
      push,
      dirtyForm,
      setDirtyFormState,
      confirmationModal,
    } = this.props //redux
    const {
      location: { pathname },
      match: {
        params: { property_id },
      },
    } = this.props //router

    let sortedProperties = properties.filter(
      (property) =>
        property.name_de.toLowerCase().includes(filterText.toLowerCase()) ||
        property.name_de.toLowerCase().includes(filterText.toLowerCase())
    )
    if (sortCol)
      sortedProperties = sortedProperties.sort(
        (a, b) =>
          typeof a[sortCol] === 'number'
            ? a[sortCol] - b[sortCol]
            : a[sortCol].localeCompare(b[sortCol])
      )
    if (sortCol && direction !== 'ascending')
      sortedProperties = sortedProperties.reverse()

    const highlight = filterText

    const highlightDefaults = {
      highlightClassName: 'highlight',
      searchWords: [highlight],
      aciveIndex: -1,
    }

    return sortedProperties.map((property) => (
      <Table.Row
        className={classNames([
          property.read_only && 'unobtrusive',
          property.product_ids &&
            property.product_ids.length === 0 &&
            'warning',
        ])}
        key={property.id}
        active={property.id === Number(property_id)}
        disabled={property.id === Number(property_id)}
        onClick={() => {
          confirmationModal({
            doNotDisplay: !dirtyForm,
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('global.abortModal.title'),
            text: I18n.t('global.abortModal.text'),
            button: I18n.t('global.abortModal.button'),
            confirm: () => {
              let basePath = pathname
              if (property_id) basePath = dirname(basePath)
              if (basePath.slice(-1) !== '/') basePath = basePath + '/'
              push(basePath + property.id)
              setDirtyFormState(false)
            },
          })
        }}>
        <Table.Cell content={property.id} className="unobtrusive" />
        <Table.Cell>
          {this.getLockedIcon(property)}
          {this.getOptionalIcon(property)}
          <span className="german tag single-line">
            {highlight ? (
              <Highlighter
                {...highlightDefaults}
                textToHighlight={property.name_de}
              />
            ) : (
              property.name_de
            )}
          </span>
          <span className="french tag single-line">
            {highlight ? (
              <Highlighter
                {...highlightDefaults}
                textToHighlight={property.name_fr}
              />
            ) : (
              property.name_fr
            )}
          </span>
        </Table.Cell>
      </Table.Row>
    ))
  }

  render() {
    const { sortCol, direction } = this.state
    return (
      <Table
        sortable
        compact
        size="small"
        selectable
        singleLine
        basic="very"
        className="spaced">
        <Table.Header>
          <Table.Row>
            <SortableHeaderCell
              textAlign="right"
              name="id"
              collapsing
              title={I18n.t('admin.property_editor.columns.id')}
              onClick={() => this.sortBy('id')}
              sortCol={sortCol}
              direction={direction}
            />
            <SortableHeaderCell
              name="name_de"
              title={I18n.t('admin.property_editor.columns.title')}
              onClick={() => this.sortBy('name_de')}
              sortCol={sortCol}
              direction={direction}
            />
          </Table.Row>
        </Table.Header>
        <Table.Body children={this.getPropertyList()} />
      </Table>
    )
  }
}

// TODO: Why do we use formValues here?
PropertiesList = formValues('filterText')(PropertiesList)
PropertiesList = connect(mapStateToProps, mapDispatchToProps)(PropertiesList)
export default withRouter(PropertiesList)



// WEBPACK FOOTER //
// ./src/components/admin/Properties/PropertiesList.jsx